import React from 'react'
import { useNavigate } from 'react-router-dom'
import type { User } from '../types/index.js'

interface DashboardProps {
  user: Pick<User, 'id' | 'username' | 'role'>
}

const Dashboard: React.FC<DashboardProps> = ({ user }) => {
  const navigate = useNavigate()
  const menuItems = [
    { icon: '📋', title: 'Orders', description: 'Manage orders and projects', testId: 'orders-card' },
    { icon: '👥', title: 'Clients', description: 'Client management', testId: 'clients-card' },
    { icon: '💰', title: 'Invoices', description: 'Billing and invoices', testId: 'invoices-card' },
    { icon: '📊', title: 'Reports', description: 'Analytics and reports', testId: 'reports-card' },
    { icon: '🛠️', title: 'Projects', description: 'Project management', testId: 'projects-card' },
    { icon: '⚙️', title: 'Settings', description: 'App configuration', testId: 'settings-card' }
  ]

  return (
    <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
      <h1 data-testid="dashboard-title" style={{ color: '#333', marginBottom: '0.5rem' }}>
        Welcome, {user.username}
      </h1>
      <p data-testid="welcome-message" style={{ color: '#666', marginBottom: '2rem' }}>
        Role: {user.role} | Zeigler Environmental Internal Dashboard
      </p>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '1.5rem',
        marginTop: '2rem'
      }}>
        {menuItems.map((item, index) => (
          <div
            key={index}
            data-testid="dashboard-item"
            data-card-id={item.testId}
            className="dashboard-item"
            style={{
              backgroundColor: 'white',
              padding: '2rem',
              borderRadius: '8px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s',
              border: '1px solid #e9ecef'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)'
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.15)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)'
            }}
            onClick={() => {
              if (item.title === 'Orders') {
                navigate('/orders')
              }
            }}
          >
            <div style={{ fontSize: '3rem', marginBottom: '1rem', textAlign: 'center' }}>
              {item.icon}
            </div>
            <h3 style={{ 
              color: '#333', 
              marginBottom: '0.5rem', 
              textAlign: 'center',
              fontSize: '1.25rem'
            }}>
              {item.title}
            </h3>
            <p style={{ 
              color: '#666', 
              textAlign: 'center',
              margin: '0',
              fontSize: '0.9rem'
            }}>
              {item.description}
            </p>
          </div>
        ))}
      </div>

      <div style={{
        marginTop: '3rem',
        padding: '1.5rem',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        border: '1px solid #e9ecef'
      }}>
        <h3 style={{ color: '#333', marginBottom: '1rem' }}>Quick Stats</h3>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem'
        }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', color: '#007bff', fontWeight: 'bold' }}>-</div>
            <div style={{ color: '#666', fontSize: '0.9rem' }}>Active Orders</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', color: '#28a745', fontWeight: 'bold' }}>-</div>
            <div style={{ color: '#666', fontSize: '0.9rem' }}>Completed This Month</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', color: '#ffc107', fontWeight: 'bold' }}>-</div>
            <div style={{ color: '#666', fontSize: '0.9rem' }}>Pending Invoices</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', color: '#17a2b8', fontWeight: 'bold' }}>-</div>
            <div style={{ color: '#666', fontSize: '0.9rem' }}>Total Clients</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard 